var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "contact-mini-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        attrs: { headerTitle: _vm.texts.title },
      }),
      _vm.showAdvice
        ? _c("StaticAlertComponent", {
            staticClass: "static-alert",
            attrs: { alert: _vm.alert },
          })
        : _vm._e(),
      _c("FormGeneratorComponent", {
        staticClass: "form-generator",
        attrs: {
          schema: _vm.formSchema,
          fieldValues: _vm.formData,
          context: _vm.context,
          formTag: "selectForm",
          showRequiredFieldsAdvice: "",
        },
        on: { saveFormData: _vm.onSaveFormData },
      }),
      _c("CustomDialogActionButtonsComponent", {
        attrs: {
          disabledButtons: _vm.formIsValid,
          mainAction: _vm.saveItems,
          primaryButtonText: _vm.texts.primaryButtonText,
        },
      }),
      _vm.loadingSpinner
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer",
            attrs: { loadingText: _vm.texts.spinnerText },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }